import styled from 'styled-components';
import { GridCardVariant } from '../../../../_shared/types/trade';

export const StyledInvalidTradeCard = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  opacity: 0.5;
  z-index: 26;
`;

export const StyledThumbnail = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  height: ${({ variant }) =>
    variant === GridCardVariant.EVENT_TRADE ? 152 : 172}px;
  background: url(${({ url }) => url || 'none'}) no-repeat;
  background-position: top;
  background-size: cover;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px 3px 0 0;
`;

export const StyledTradeStatus = styled.div`
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  z-index: 27;
  position: absolute;
  top: 6px;
  margin-left: 6px;
  margin-right: 6px;
  left: 0;
  right: 0;
  text-align: center;
  padding: 4px;
  border-radius: 3px;
  pointer-events: none;
  width: fit-content;
`;

export const StyledActiveTimer = styled.div`
  background: ${({ theme }) => theme.COLORS.BASE};
  position: absolute;
  top: 6px;
  left: 6px;
  padding: 2px 15px;
  border-radius: 3px;
  z-index: 27;
  pointer-events: none;
`;

export const StyledBidBadgeContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 0;
`;

export const StyledMakeModelYearContainer = styled.div`
  width: 100%;
  min-height: 92px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 6e-5) 39.13%,
    rgba(0, 0, 0, 0.48) 86.96%
  );
`;

export const StyledMakeModelYear = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 10px;
  width: 100%;
`;

export const StyledMakeModel = styled.div`
  margin-top: 5px;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  color: ${({ theme }) => theme.COLORS.BASE};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledModel = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;
